module.exports = __webpack_public_path__ + "static/media/COMMON-1.fae8be6b.jpg";